import * as React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";

const Label = ({ mark, last, renderLabel }) => (
  <span
    className={gatherClasses(
      null,
      "oui-slider-mark",
      last ? "oui-last-mark" : ""
    )}
  >
    <span className="oui-slider-mark-content">{renderLabel(mark)}</span>
  </span>
);

Label.propTypes = {
  mark: PropTypes.number.isRequired,
  last: PropTypes.bool,
  renderLabel: PropTypes.func
};

Label.defaultProps = {
  last: false,
  renderLabel: label => label
};

Label.displayName = "OrionSliderLabel";

export default Label;
